// extracted by mini-css-extract-plugin
export default {"textLink":"textLink___B2JcM","standalone":"standalone___wLb3V","large":"large___Zehn7","small":"small___xL4Ss"};